import { ProductCategory } from "@utils/constants";
import Routes from "@apis/routes";

export type IncludedCategories = Exclude<
  ProductCategory,
  ProductCategory.LABGROWN_JEWELRY | ProductCategory.DEFAULT
>;

type ProductRequestParamsType = {
  [K in
    | ProductCategory.JEWELRY
    | ProductCategory.DIAMOND
    | ProductCategory.LAB_GROWN_DIAMOND
    | ProductCategory.LABGROWN_JEWELRY
    | ProductCategory.GEMSTONE]: {
    queryKey: string;
    route: string;
    idName: string;
    stockNum?: string;
  };
};

export const ProductRequestParams: ProductRequestParamsType = {
  [ProductCategory.DIAMOND]: {
    queryKey: "get_diamonds_by_id",
    route: Routes.GET_DIAMOND_BY_ID,
    idName: "diamond_ids",
  },
  [ProductCategory.LAB_GROWN_DIAMOND]: {
    queryKey: "get_diamonds_by_id",
    route: Routes.GET_DIAMOND_BY_ID,
    idName: "diamond_ids",
  },
  [ProductCategory.GEMSTONE]: {
    queryKey: "GemstoneByID",
    route: Routes.GET_GEMSTONE_BY_ID,
    idName: "gemstone[gemstone_ids][]",
  },
  [ProductCategory.JEWELRY]: {
    queryKey: "get_jewelry_by_id",
    route: Routes.GET_JEWELRY_BY_ID,
    idName: "jewelry[jewelry_ids][]",
    stockNum: "jewelry[stock_num]",
  },
  [ProductCategory.LABGROWN_JEWELRY]: {
    queryKey: "get_jewelry_by_id",
    route: Routes.GET_JEWELRY_BY_ID,
    idName: "jewelry[jewelry_ids][]",
    stockNum: "jewelry[stock_num]",
  },
};
